import React from 'react'
import { DeviceConsumer } from './DeviceContext'

function withDeviceContext(WrappedComponent) {
    return class extends React.Component {
        constructor(props) {
            super(props)
        }


        render() {

            return <DeviceConsumer>{({ device }) => ( <WrappedComponent device={device} {...this.props}/>)}</DeviceConsumer>
        }
    };
}


export default withDeviceContext



// WEBPACK FOOTER //
// components/WithDeviceContext.js